import type { SVGProps } from "react";
import * as React from "react";

const SvgHeadphones = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 18a1 1 0 1 0 2 0zm1-6H2zm9-9v1zm9 9h1zm-1 6a1 1 0 1 0 2 0zm-4 1h1zm0-3h1zm2-2v1zm3 0h1a1 1 0 0 0-1-1zM3 19H2zm5 0h1zm0-3h1zm-5-2v-1a1 1 0 0 0-1 1zm1 4v-6H2v6zm0-6a8 8 0 0 1 2.343-5.657L4.93 4.93A10 10 0 0 0 2 12zm2.343-5.657A8 8 0 0 1 12 4V2a10 10 0 0 0-7.071 2.929zM12 4a8 8 0 0 1 5.657 2.343L19.07 4.93A10 10 0 0 0 12 2zm5.657 2.343A8 8 0 0 1 20 12h2a10 10 0 0 0-2.929-7.071zM20 12v6h2v-6zm0 7a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 22 19zm-.293.707A1 1 0 0 1 19 20v2a3 3 0 0 0 2.121-.879zM19 20h-1v2h1zm-1 0a1 1 0 0 1-.707-.293l-1.414 1.414A3 3 0 0 0 18 22zm-.707-.293A1 1 0 0 1 17 19h-2a3 3 0 0 0 .879 2.121zM17 19v-3h-2v3zm0-3a1 1 0 0 1 .293-.707l-1.414-1.414A3 3 0 0 0 15 16zm.293-.707A1 1 0 0 1 18 15v-2a3 3 0 0 0-2.121.879zM18 15h3v-2h-3zm2-1v5h2v-5zM2 19a3 3 0 0 0 .879 2.121l1.414-1.414A1 1 0 0 1 4 19zm.879 2.121A3 3 0 0 0 5 22v-2a1 1 0 0 1-.707-.293zM5 22h1v-2H5zm1 0a3 3 0 0 0 2.121-.879l-1.414-1.414A1 1 0 0 1 6 20zm2.121-.879A3 3 0 0 0 9 19H7a1 1 0 0 1-.293.707zM9 19v-3H7v3zm0-3a3 3 0 0 0-.879-2.121l-1.414 1.414A1 1 0 0 1 7 16zm-.879-2.121A3 3 0 0 0 6 13v2a1 1 0 0 1 .707.293zM6 13H3v2h3zm-4 1v5h2v-5z"
    />
  </svg>
);
export default SvgHeadphones;
